// eslint-disable-next-line import/prefer-default-export
export function getProduct(blueprint, handle) {
    return new Promise((resolve) => {
        const storefrontUrl = blueprint.custom['v-storefront'];
        const accessKey = blueprint.custom['v-storefront-token'];

        const query = {
            query: `
                query getProductByHandle($id: String!) {
                    product(handle: $id) {
                        title
                        priceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                            maxVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        variants(first:100) {
                            edges {
                                node {
                                    id
                                    quantityAvailable
                                    sku
                                    price {
                                        amount
                                        currencyCode
                                    }
                                }
                            }
                        }
                    }
                }
                `,
            variables: {
                id: `${handle}`,
            },
            operationName: 'getProductByHandle',
        };

        fetch(storefrontUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': accessKey,
            },
            body: JSON.stringify(query),
        })
            .then((response) => response.json())
            .then((data) => {
                const variants = [];

                data?.data?.product?.variants?.edges?.forEach((variant) => {
                    if (variant.node?.price?.amount) {
                        // eslint-disable-next-line prefer-destructuring
                        const sku = variant.node.sku;
                        const ats = parseFloat(variant.node.quantityAvailable);
                        const price = parseFloat(variant.node.price.amount);
                        const currency = variant.node.price.currencyCode;

                        variants.push({
                            variant: variant.node.id,
                            sku,
                            ats,
                            price,
                            currency,
                        });
                    }
                });

                resolve(variants);
            });
    });
}

// eslint-disable-next-line import/prefer-default-export
export function getVariantById(blueprint, id, variantId) {
    return new Promise((resolve) => {
        const storefrontUrl = blueprint.custom['v-storefront'];
        const accessKey = blueprint.custom['v-storefront-token'];

        const query = {
            query: `
                {
                    node(id: "gid://shopify/Product/${id}") {
                    ... on Product {
                        id
                        title
                        variants(first:100) {
                            edges {
                                node {
                                    id
                                    quantityAvailable
                                    sku
                                    price {
                                        amount
                                        currencyCode
                                    }
                                }
                            }
                        }
                    }
                }
            }
            `,
        };

        fetch(storefrontUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': accessKey,
            },
            body: JSON.stringify(query),
        })
            .then((response) => response.json())
            .then((data) => {
                const variants = [];

                data?.data?.node?.variants?.edges?.forEach((variant) => {
                    let matches = false;

                    // Take the first variant.
                    if (variantId == null) {
                        if (variants.length === 0) {
                            matches = true;
                        }
                    } else {
                        matches = variant.node?.id === `gid://shopify/ProductVariant/${variantId}`;
                    }

                    if (matches && variant.node?.price?.amount) {
                        // eslint-disable-next-line prefer-destructuring
                        const sku = variant.node.sku;
                        const ats = parseFloat(variant.node.quantityAvailable);
                        const price = parseFloat(variant.node.price.amount);
                        const currency = variant.node.price.currencyCode;

                        variants.push({
                            variant: variant.node.id,
                            sku,
                            ats,
                            price,
                            currency,
                        });
                    }
                });

                resolve(variants);
            });
    });
}
